/**
 * FormSection Component
 * 
 * Reusable component that creates a styled section within a form
 * with a title and content area for field groups.
 */
import React from 'react';

const FormSection = ({ title, children, className = '' }) => {
  return (
    <div className={`bg-gray-50 p-4 rounded-md border border-gray-200 ${className}`}>
      <h3 className="text-md font-medium mb-3 text-gray-700">{title}</h3>
      {children}
    </div>
  );
};

export default FormSection; 